import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { CommonInfo } from '../views/pages/app.config';
import { environment } from "src/environments/environment";
import { DataService } from './data.service';
import { NavigationService } from './navigation.service';
import { GlobalProvider } from './backnavigation';


@Injectable({
  providedIn: 'root'
})
export class StudenttransformService {
  
 sharedData: any [];

  public publicUrl = environment.apipublicUrl;


  constructor(private http: HttpClient,
    private dataService: DataService,
    private navigationService: NavigationService,
    public pages: GlobalProvider,
  ) {
    // this.pages.sharedData = 0;
   }
    
    setData(datano: Number , stdenid: number) {
      if(datano == 1){
        this.pages.sharedData = datano
        this.pages.sharedstudentid = stdenid
      this.navigationService.goTostudentpage();
      }
    }

    // /api/studentacademicinfo/SaveTransferApprovedByInstitute

    saveSaveTransferApprovedByInstitute(result: any) {
      return this.dataService.post('/api/studentacademicinfo/SaveTransferApprovedByInstitute', result).map(response => {
        return response;
      });
    }
  
    // getData() {
    //   debugger
    //   // this.setData();
    //    if (!this.sharedData) {
    //   console.error('No data available in the service.');
    // }else{
    //   return this.sharedData ? this.pages.sharedData : [];
      
    // }
    // }
}
